var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { moneyFormatter } from '@utex/ui-kit';
export var useMoneyFormatter = function (opts) {
    return moneyFormatter(__assign({}, opts));
};
//# sourceMappingURL=useMoneyFormatter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/hooks/useMoneyFormatter.js
// module id = 1374
// module chunks = 118